export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_01.7c18d4da.jpg";